// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jzon from "rescript-jzon/lib/es6/src/Jzon.res.js";
import * as LumiDate from "lumi-rescript/lib/es6/src/LumiDate.res.js";
import * as LumiJzon from "lumi-rescript/lib/es6/src/LumiJzon.res.js";
import * as Stdlib_Result from "@rescript/runtime/lib/es6/Stdlib_Result.js";
import * as Document$LumiStore from "lumi-store/lib/es6/src/Document.res.js";

let jsonCodec = LumiJzon.taggedVariantOptionalContents(state => {
  if (typeof state !== "object") {
    return [
      "NotSynchronized",
      undefined
    ];
  }
  switch (state.TAG) {
    case "Checked" :
      return [
        "Checked",
        Jzon.encodeWith(state._0, LumiDate.DateTime.jsonCodec)
      ];
    case "CopiedToSensor" :
      return [
        "CopiedToSensor",
        Jzon.encodeWith(state._0, LumiDate.DateTime.jsonCodec)
      ];
    case "CopiedFromSensor" :
      return [
        "CopiedFromSensor",
        Jzon.encodeWith(state._0, LumiDate.DateTime.jsonCodec)
      ];
  }
}, pair => {
  let other = pair[0];
  switch (other) {
    case "Checked" :
      let json = pair[1];
      if (json !== undefined) {
        return Stdlib_Result.map(Jzon.decodeWith(json, LumiDate.DateTime.jsonCodec), stamp => ({
          TAG: "Checked",
          _0: stamp
        }));
      }
      break;
    case "CopiedFromSensor" :
      let json$1 = pair[1];
      if (json$1 !== undefined) {
        return Stdlib_Result.map(Jzon.decodeWith(json$1, LumiDate.DateTime.jsonCodec), stamp => ({
          TAG: "CopiedFromSensor",
          _0: stamp
        }));
      }
      break;
    case "CopiedToSensor" :
      let json$2 = pair[1];
      if (json$2 !== undefined) {
        return Stdlib_Result.map(Jzon.decodeWith(json$2, LumiDate.DateTime.jsonCodec), stamp => ({
          TAG: "CopiedToSensor",
          _0: stamp
        }));
      }
      break;
    case "NotSynchronized" :
      return {
        TAG: "Ok",
        _0: "NotSynchronized"
      };
  }
  return {
    TAG: "Error",
    _0: {
      NAME: "UnexpectedJsonValue",
      VAL: [
        [],
        other
      ]
    }
  };
}, undefined, undefined);

let SyncState = {
  jsonCodec: jsonCodec
};

let jsonCodec$1 = Jzon.object6(param => [
  param.deviceName,
  param.softwareVersion,
  param.softwareId,
  param.firmwareVersion,
  param.firmwareDate,
  param.bootLoaderId
], param => ({
  TAG: "Ok",
  _0: {
    deviceName: param[0],
    softwareVersion: param[1],
    softwareId: param[2],
    firmwareVersion: param[3],
    firmwareDate: param[4],
    bootLoaderId: param[5]
  }
}), Jzon.field("deviceName", Jzon.string), Jzon.field("softwareVersion", Jzon.string), Jzon.field("softwareId", Jzon.string), Jzon.field("firmwareVersion", Jzon.string), Jzon.field("firmwareDate", Jzon.string), Jzon.field("bootLoaderId", Jzon.string));

let NewNameplate = {
  jsonCodec: jsonCodec$1
};

let NewSettings = {
  jsonCodec: Jzon.json
};

let jsonCodec$2 = Jzon.object4(param => [
  param.nameplate,
  param.nameplateSync,
  param.settings,
  param.settingsSync
], param => ({
  TAG: "Ok",
  _0: {
    nameplate: param[0],
    nameplateSync: param[1],
    settings: param[2],
    settingsSync: param[3]
  }
}), Jzon.field("nameplate", jsonCodec$1), Jzon.field("nameplateSync", jsonCodec), Jzon.field("settings", Jzon.json), Jzon.field("settingsSync", jsonCodec));

let NewUltrasonicSensor = {
  NewNameplate: NewNameplate,
  NewSettings: NewSettings,
  jsonCodec: jsonCodec$2
};

let jsonCodec$3 = Jzon.object3(param => [
  param.deviceName,
  param.softwareVersion,
  param.hardwareVersion
], param => ({
  TAG: "Ok",
  _0: {
    deviceName: param[0],
    softwareVersion: param[1],
    hardwareVersion: param[2]
  }
}), Jzon.field("deviceName", Jzon.string), Jzon.field("softwareVersion", Jzon.string), Jzon.field("hardwareVersion", Jzon.string));

let OldNameplate = {
  jsonCodec: jsonCodec$3
};

let OldSettings = {
  jsonCodec: Jzon.json
};

let jsonCodec$4 = Jzon.object4(param => [
  param.nameplate,
  param.nameplateSync,
  param.settings,
  param.settingsSync
], param => ({
  TAG: "Ok",
  _0: {
    nameplate: param[0],
    nameplateSync: param[1],
    settings: param[2],
    settingsSync: param[3]
  }
}), Jzon.field("nameplate", jsonCodec$3), Jzon.field("nameplateSync", jsonCodec), Jzon.field("settings", Jzon.json), Jzon.field("settingsSync", jsonCodec));

let OldUltrasonicSensor = {
  OldNameplate: OldNameplate,
  OldSettings: OldSettings,
  jsonCodec: jsonCodec$4
};

let jsonCodec$5 = LumiJzon.taggedVariant(value => {
  if (value.TAG === "NewSensorType") {
    return [
      "NewSensorType",
      Jzon.encodeWith(value._0, jsonCodec$2)
    ];
  } else {
    return [
      "OldSensorType",
      Jzon.encodeWith(value._0, jsonCodec$4)
    ];
  }
}, param => {
  let json = param[1];
  let tag = param[0];
  switch (tag) {
    case "NewSensorType" :
      return Stdlib_Result.map(Jzon.decodeWith(json, jsonCodec$2), x => ({
        TAG: "NewSensorType",
        _0: x
      }));
    case "OldSensorType" :
      return Stdlib_Result.map(Jzon.decodeWith(json, jsonCodec$4), x => ({
        TAG: "OldSensorType",
        _0: x
      }));
    default:
      return {
        TAG: "Error",
        _0: {
          NAME: "UnexpectedJsonValue",
          VAL: [
            [],
            tag
          ]
        }
      };
  }
}, undefined, undefined);

let UltrasonicSensorType = {
  jsonCodec: jsonCodec$5
};

let jsonCodec$6 = Jzon.object5(param => [
  param.modbusTcpConverter,
  param.modbusAddress,
  param.modbusLine,
  param.modbusLinePosition,
  param.type_
], param => ({
  TAG: "Ok",
  _0: {
    modbusTcpConverter: param[0],
    modbusAddress: param[1],
    modbusLine: param[2],
    modbusLinePosition: param[3],
    type_: param[4]
  }
}), Jzon.field("modbusTcpConverter", Document$LumiStore.Key.jsonCodec()), Jzon.field("modbusAddress", Jzon.int), Jzon.field("modbusLine", Jzon.string), Jzon.field("modbusLinePosition", Jzon.int), Jzon.field("type", jsonCodec$5));

let UltrasonicSensor = {
  jsonCodec: jsonCodec$6
};

export {
  SyncState,
  NewUltrasonicSensor,
  OldUltrasonicSensor,
  UltrasonicSensorType,
  UltrasonicSensor,
}
/* jsonCodec Not a pure module */
